module.exports = __webpack_public_path__ + "./docs/img/kit-references.051584b0a111075f5a3572ddba5987e8.svg";